var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clipboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.658,
    height: 26,
    viewBox: "0 0 25.658 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_288",
    "data-name": "Tracciato 288",
    d: "M8.949,11C7.872,11,7,11.348,7,11.778s.872.778,1.949.778H24.458c1.076,0,1.949-.348,1.949-.778S25.534,11,24.458,11Z",
    transform: "translate(-3.89 1.052)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_289",
    "data-name": "Tracciato 289",
    d: "M8.989,15.066c-1.076,0-1.949.348-1.949.778s.872.778,1.949.778H24.5c1.076,0,1.949-.348,1.949-.778s-.872-.778-1.949-.778Z",
    transform: "translate(-3.899 3.111)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_290",
    "data-name": "Tracciato 290",
    d: "M5.851,3A2.851,2.851,0,0,0,3,5.851V25.807a2.851,2.851,0,0,0,2.851,2.851H25.807a2.851,2.851,0,0,0,2.851-2.851V5.851A2.851,2.851,0,0,0,25.807,3ZM8.7,5.851H5.851V25.807H25.807V5.851H22.956V7.276a4.276,4.276,0,0,1-4.276,4.276h-5.7A4.276,4.276,0,0,1,8.7,7.276Zm2.851,0V7.276A1.425,1.425,0,0,0,12.978,8.7h5.7a1.425,1.425,0,0,0,1.425-1.425V5.851Z",
    transform: "translate(-3 -3)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.3a0cadeb8eee59f0ef18f14d7243ff74.svg";
export { ForwardRef as ReactComponent };